<template>
  <div data-color="clear" class="js-header-panel">
     <div class="c-page c-blog u-pad-x-w1of12 u-pad-x-w1of12@sm u-pad-t-xl u-pad-t-ultra@sm">

  <section   data-color="clear"   class="u-relative   js-header-panel is-active u-pad-t-xl u-pad-t-ultra@sm"  >
    <div class="u-fit-w">
      <div class="t-text--md--bold1 u-marg-l-sm u-marg-r-sm   privinvest-box-page   t-text--md--bold@md u-relative">
                  <span class="c-home__section__upcomingprogram_title   c-inspire-title--color">
                      <svg viewBox="0 0 173 25" >
                          <text x="0" y="15" class="u-color--white--fill">{{contentNavalVessel.title}}</text>
                        </svg>
                      </span>
                  <!--<span  class="c-line c-line--x u-absolute u-pos-bl u-bg--white u-fit-w"></span>-->
                </div>
     </div>
<div v-if="areThereCategories"  v-for="(postcat,topindex)  in pagecategories"  :data-index="topindex"  class="o-wrapper--valign  u-fit inspire-Custom-Container u-marg-x-auto u-marg-y-xs35 u-marg-y-sm@sm">
  <div class="u-fit-w">
    <div class="t-text--md--bold u-marg-l-sm u-marg-r-sm privinvest-box-page t-text--md--bold@md u-relative">
                <span class="c-home__section__upcomingprogram_title   c-inspire-title--color">
                      <svg viewBox="0 0 300  20" v-if="postcat.line==='2'" >
                          <text x="0" y="18" class="u-color--white--fill">{{postcat.name}}</text>
                        </svg>
                        <svg viewBox="0 0 300 22" v-else >
                            <text x="0" y="20" class="u-color--white--fill">{{postcat.name}}</text>
                          </svg>
                  </span>
                <!--<span  class="c-line c-line--x u-absolute u-pos-bl u-bg--white u-fit-w"></span>-->
              </div>
   </div>
   <div class="u-fit-w" v-if="postcat.line==='2'">
     <div class="t-text--md--bold u-marg-l-sm u-marg-r-sm privinvest-box-page t-text--md--bold@md u-relative">
                 <span class="c-home__section__upcomingprogram_title   c-inspire-title--color">
                       <svg viewBox="0 0 300 22" >
                           <text x="0" y="20" class="u-color--white--fill">{{postcat.namel2}}</text>
                         </svg>
                   </span>
                 <!--<span  class="c-line c-line--x u-absolute u-pos-bl u-bg--white u-fit-w"></span>-->
               </div>
    </div>
    <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none is-active"></div>
        <div class="c-home__section__fade u-pad-t-xs@sm u-relative u-zindex--3 u-flex u-flex-fd--column@md  u-fit-w">
              <div class="c-team__content  u-marg-t-md  u-w2of2 " >
                  <section class="u-relative u-pad-b-xl u-pad-b-xs@sm" :class="{'border-1-l-white':(topindex+1)%2==0,'border-1-r-white':(topindex+1)%2!=0}">
                    <div class="c-team__section-container u-relative  u-pad-y-lg@sm ">
                        <div class="c-team__section">
                              <div class="u-flex u-flex-fw--wrap u-flex-jc--space-between">
                                    <a class="c-team__link  t-link u-marg-b-xxl"  :class="{'isDisabled':post.Enable===false}"  href="javascript:void(0);"  v-for="(post,index)  in contentNavalVessel[postcat.id]"  :data-index="index"   :title="post.title" :id="(post.title).replace(/\s/g,'')"  @click="onOpenPopin(post,index,postcat.id)"  @mouseenter="onHoverPopin((post.title).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((post.title).replace(/\s/g,''),index)"  >
                                        <div class="single-model-header" v-if="post.Enable===true">
                                        <!--  <a class="single-model-header-under" href="/">-->
                                          <h2 class="single-model-header__title">
                                            <div class="single-model-header__model">
                                            <div class="single-model-header__container">
                                              <!--    <span class="single-model-header__newModel">
                                              <span class="single-model-header__marketingLabelRow">2019</span>
                                                </span>
                                                -->
                                                <span class="single-model-header__modelName">{{post.title}}</span>
                                                 </div>
                                               </div>
                                             </h2>
                                             <span class="cta__text--160Lr"></span>
                                           <!--</a>-->
                                           <p class="single-model-header__priceContainer">
                                            <button  class="c-footer__btn-submit t-btn t-btn--primary-ms t-text--xs u-relative u-color--white  u-w1of2-1" @click="onOpenPopinPHOTOS(post,index)"  style="margin-right:3px;" ><span>more specs</span></button>
                                            <button  class="c-footer__btn-submit t-btn t-btn--primary-ms t-text--xs u-relative u-color--white  u-w1of2-1" @click="onOpenPopin(post,index)"  ><span>more photos</span></button>

                                             </p>
                                           </div>

                                         <!--<h2 class="t-h5 t-text--roman u-marg-b-xs u-color--white">{{post.titledesc}}</h2>-->
                                        <div class="c-team__link__photo-container js-photo-container u-relative o-box--1by3  u-overflow-h u-force-3d" >
                                              <div class="c-team__link__photo__overlay--middle u-absolute u-pos-t u-zindex--2"></div>
                                              <img class="c-team__link__photo  u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(post.Stock_No).replace(/\s/g,'')"  :src="post.images[0].sizes.medium_large"     :alt="post.title"   ></img>
                                        </div>
                                      <div class=" u-pad-t-sm u-bg--Inspireblue" >
                                        <h4 class="t-text--sm  u-align-left  c-inspire-pcomingp---boxblue u-color--white">{{post.titledesc}}</h4>
                                         <!--<h4 class="t-text--sm  u-color--white   c-inspire-pcomingp---boxblue u-align-center">{{post.Stock_No}}</h4>-->
                                       </div>
                                       <div>
                                          <!--<h4 class="t-text--xs  u-align-left  c-inspire-pcomingp---boxblue-blog__article__date u-color--gray">{{post.Year}}</h4>
                                         <h4 class="t-text--xs  u-align-left  c-inspire-pcomingp---boxblue-blog__article__date u-color--gray">{{post.Stock_No}}</h4>-->
                                          <h4 class="t-text--xs  u-align-left   u-color--white  c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="post.first_paragraph_shorted" ></h4>
                                        </div>
                                 </a>

                                </div>
                            </div>
                    </div>
                  </section>

              </div>
        </div>
      </div>
</section>

     </div>

       <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
       <app-car-details   :content="popinContent"  :key="componentKey"  :title="popinTitle" :index="0"  :isActive="isPopinActive"  ></app-car-details>
       <app-car-photos   :content="popinContent" :key="componentKey2"  :title="popinTitle" :index="0"  :isActive="isPopinActivePhotos"  ></app-car-photos>
  </div>


</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import   CoreAjaxForm from     '../core-ajax-form/index.vue'
import AppTeamBoardPopin from '../app-team-board-popin/index.vue'
import AppCarDetailsPopin from '../app-car-details/index.vue'
import AppCarDetailsPhotos from '../app-car-photos/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
import AppScrollObject from '../app-scroll-object/index.vue'

export default
{
          components:{

                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter,
                                    'core-ajax-form':CoreAjaxForm,
                                    'app-car-details':AppCarDetailsPopin,
                                    'app-car-photos':AppCarDetailsPhotos,
                                    "app-scroll-object":AppScrollObject,
                                   AppTeamBoardPopin

                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1,
                          areThereCategories: !1,
                          selectedOption:'',
                          CarModel:Object(),
                           popinContent: null,
                           popinTitle: null,
                            isPopinActive: !1,
                            isPopinActivePhotos: !1,
                            isButtonClicked:false,
                            isButtonVisible: !0,
                            isButtonActive: !1,
                              componentKey: 0,
                              componentKey2:1,
                            uiexplore:"Scroll to discover"
                      }
                  },
                  computed:
                  {
                    contentNavalVessel: function()
                     {
                         return  this.adminContent.en.commercial_vessels
                     },
                    content: function()
                     {
                         return   this.adminContent.en.pages.CurrentStock
                     },
                     getsearchContent: function()
                      {
                          return   this.adminContent.en.pages.SearchContent
                      },
                        computedPostsCategories: function()
                        {
                          var t = [];

                              if (Object.keys(this.adminContent.en.commercial_vessels).length > 0)
                              {
                                  if (this.adminContent.en.commercial_vessels.categories)
                                  {
                                      this.areThereCategories = !0;
                                      var   n = this.adminContent.en.commercial_vessels.categories.length;
                                      for (var e = 0;e < n; e += 1)
                                      {
                                          var r =  this.adminContent.en.commercial_vessels.categories[e];
                                           t.push(r)
                                      }

                                  }
                                  else
                                  {
                                   this.areThereCategories = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }


                          return t
                        }
                        ,
                      computedPosts: function()
                      {
                          var t = [];
                            this.areTherePosts = !0;
                            var   n = this.adminContent.en.commercial_vessels[1].length;
                            for (var e = 0;e < n; e += 1)
                                {
                                          var r = this.adminContent.en.commercial_vessels[1][e];
                                         t.push(r)
                                  }
                                this.popinContent =   t[0]
                              return t
                      },
                      computedPages: function()
                      {
                          var t = [];
                          if (this.$route.query.page) {
                              t.length = 0;
                              for (var e = 0, n = Object.keys(this.adminContent.en.commercial_vessels).length; e < n; e += 1) {
                                  var r = Object.keys(this.adminContent.en.commercial_vessels)[e];
                                  t.push({
                                      index: parseInt(r, 10),
                                      isVisible: !0
                                  })
                              }
                          }
                          return t
                      },
                      computedCurrentPageIndex: function()
                      {
                          var t = 1;
                          return t = this.adminContent.en.commercial_vessels[1]
                      }
                  },
                  beforeCreate: function()
                  {
                      //this.$route.query.page || this.$router.push("/theelitecars/current-stock?page=1")
                  },
                  created: function()
                  {
                      //this.adminContent.en.pages.blog.blog_is_active ? this.$route.query.page || this.$router.replace("/theelitecars/current-stock?page=1") : this.$router.replace("/404"),
                      this.onResize = this.onResize.bind(this),
                      this.posts = this.computedPosts,
                      this.pages = this.computedPages,
                      this.pagecategories =this.computedPostsCategories,
                      this.currentPageIndex = this.computedCurrentPageIndex,
                      this.eventHub.$on("close:popin", this.onClosePopin),
                      this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("close:popin", this.onClosePopin),
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                    setTimeout(function() {this.isButtonVisible = !0}, 120),
                    setTimeout(function() {this.isButtonActive = !0}, 3e3),
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {
                        forceRerender() {
                          this.componentKey += 1;
                         this.componentKey2 += 1;
                    },
                      onResize: function() {},
                      onOpenPopin: function (t, e)
                      {
                          this.forceRerender();
                          if(this.isButtonClicked)
                             return false;
                            // alert("popin main no");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =   t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                            this.eventHub.$emit("open:popin"),
                          setTimeout(function ()
                          {
                              n.isPopinActive = !0,
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onOpenPopinPHOTOS: function (t, e)
                      {
                          this.forceRerender();
                          this.isButtonClicked=true;
                          //alert("popin photo");
                          var n = this;
                          this.popinIndex = 0,
                          this.popinContent =   t,
                          this.popinTitle =   t.title,
                          this.eventHub.$emit("disable:scroll"),
                            this.eventHub.$emit("open:popin"),
                          //this.eventHub.$emit("open:popinphotos"),
                          setTimeout(function ()
                          {
                              n.isButtonClicked=false;
                              n.isPopinActivePhotos = !0,
                              //n.$el.classList.add("is-popin-active--photos"),
                              n.$el.classList.add("is-popin-active"),
                              n.onTransition()
                          }, 50)
                      },
                      onHoverPopin: function (t, e)
                      {

                             var n = this;

                              n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars--back"),
                              n.$el.querySelector('#'+t).classList.add("is-start-switching--cars")

                      },
                      onHoverOutPopin: function (t, e)
                      {
                         var n = this;
                           n.$el.querySelector('#'+t).classList.remove("is-start-switching--cars"),
                          n.$el.querySelector('#'+t).classList.add("is-start-switching--cars--back")

                      },
                      onClosePopin: function ()
                      {
                          this.eventHub.$emit("enable:scroll"),

                          this.isPopinActive = !1,
                          this.isPopinActivePhotos = !1,
                          //this.isBoardActive = !1,
                          this.$el.classList.remove("is-popin-active"),
                          this.onTransition()

                      },
                      onTransition: function ()
                      {
                          var t = this;
                          this.$el.classList.add("is-switching"),
                          clearTimeout(this._timerTransition),
                          this._timerTransition = setTimeout(function () {
                              t.$el.classList.remove("is-switching")
                          }, 650)
                      }
                  }
    }

</script>
<style  scoped>
/*SVG ICON SYSTEM*/
.icon {
    display: inline-flex;
    align-self: center;
}

.icon svg, .icon img {
    height: 2rem;
    width: 2rem;
    fill: currentColor;
}

.icon.baseline svg, .icon img {
    top: .125em;
    position: relative;
}




h3 {
    margin:0 0 5px 0;
    padding:0;
    line-height:1;
    font-weight:normal;
  position:relative;
  color: #000;
}
/*H Tag Sizing*/


h3 {
  font-size: 15px;
}
.containercarousel_Image .style-3 ins {
    font-weight: 200;
    text-decoration: none;
    padding: 0px;
    margin:0px;
    color: #d93746;
}
.containercarousel_Image .blockdownInfo {
    -webkit-transition: .5s ease;
    transition: .5s ease;
    opacity: 1;
    position: relative;
    top: 0;
    left: 0;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    text-align: left;
}
.containercarousel_Image {
    position: relative;
    padding: 0px;
}
.icontext
{
  position:relative;
  top:-10px;
  left: -8px

}
.t-btn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}
.t-btn:hover {
  opacity: 0.5;
}
/*
.t-btn span:after {
  content: '\00bb';
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

.t-btn:hover span {
  padding-right: 25px;
}

.t-btn:hover span:after {
  opacity: 1;
  right: 0;
}*/
@media screen and (max-width: 550px)
{
  .t-btn span:after {
    content: '';
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    transition: 0.5s;
  }
  /*.t-btn:hover span {
    padding-right: 0px;
  }
  .t-btn:hover span:after {
    opacity: 0;
    right: 0;
  }*/
  .icon svg, .icon img {
      height: 1.5rem;
      width: 1.5rem;
      fill: currentColor;
  }
  .icontext
  {
    position:relative;
    top:-5px;
    left: -5px

  }
  .text-center--sm
  {
     text-align: center;
  }
}
</style>
